<cx-icon class="icon" [type]="iconType.ARROW_NAVIGATE"></cx-icon>
<ng-content></ng-content>
